// shared/TabButton.jsx
// Reusable tab button component for competitive analysis navigation
// Extracted from CompetitiveAnalysisView.jsx for better reusability

import React from 'react';

/**
 * Tab button component with active/inactive styling
 * @param {Object} props - Component props
 * @param {boolean} props.active - Whether this tab is currently active
 * @param {React.ReactNode} props.children - Tab button content
 * @param {Function} props.onClick - Click handler function
 * @returns {JSX.Element} Styled tab button
 */
const TabButton = ({ active, children, onClick }) => (
    <button
        onClick={onClick}
        className={`px-4 py-2 text-sm rounded-lg ${active
            ? 'bg-blue-100 text-blue-700'
            : 'text-gray-600 hover:bg-gray-100'
            }`}
    >
        {children}
    </button>
);

export default TabButton;
